import React, { useContext, useEffect, useRef, useState } from 'react'
import DynamicReport from '../../Components/DynamicReport/DynamicReport'
import { EditOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from 'react-router-dom';
import { ActionHandlerProvider, useActionHandler } from '../../Components/ActionHandlerContext';
import { API } from '../../Axios/Axios';
import { empFormData, fetchAllDocofEmployee, getFormData, getInvestmentCycleForVerification, updateEmployeeSubmissionFinalDetails, viewFile } from '../../Helpers/APIEndpoints/Endpoints';
import { useAuthStore } from '../../AuthStore/AuthStore';
import { message, Modal } from 'antd';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { LoaderContext } from '../../Helpers/Context/Context';
import JSZip from "jszip";
import {saveAs} from "file-saver";

const EmployeeRecord = () => {
  const [dashboardId, setDashboardId] = useState<any>(10);
  const navigate = useNavigate();
  const { rowActionHandler, reportActionHandler } = useActionHandler();
  const{currentFinancialYearId,userId,currentuserroleList}= useAuthStore();
  const[empName, setEmpName] = useState<any>();
  const[panNo, setPanNo] = useState<any>();
  const[mobNo, setMobNo] = useState<any>();
  const[financialYear, setFinancialYear] = useState<any>();
  const[fatherName, setFatherName] = useState<any>()
  const[address, setAddress] = useState<any>()
  
  const [formData, setFormData] = useState<any>([])
  const targetRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const usrRoleListArr = (Array.isArray(currentuserroleList) ? currentuserroleList : []).map((role: any) => role.Id);
  const { confirm } = Modal;

  //console.log('user role list array==>',usrRoleListArr)
  //console.log('current user role list==>',currentuserroleList)
  
  const childRowHandlers = {
    ...rowActionHandler, // Merge Parent's rowActionHandler
    DynamicMasterRowEdit:
      //((record:any) => {
      ((actionType: any, record: any) => {      
        navigate("/VerificationDashboard", {
          state: { userId : record.EmployeeUserId },
        });
      }),
      DynamicMasterRowReset : ((actionType: any,record : any)=>{
        return resetHandle(record);
      }),
      DynamicMasterRowDownload : (async(actionType: any,record : any)=>{
        await formDownloadHandle(record);
      }),
      DynamicMasterBulkDownload : (async(actionType: any,record : any)=>{
        return bulkDataDownload(record);
      }),
      DynamicMasterViewDeclaration : (async(actionType: any,record : any)=>{
      //   console.log('record is ',record)
        navigate("/EmployeeTabs", {
        state: {
          userId: record?.EmployeeUserId,
          activeTab: "2", // Show Declarations tab
        },
      });
        return; //bulkDataDownload(record);
      })

    // DynamicMasterRowDelete:
    //   ((actionType: any, record: any) => {
    //     handleDeleteConfiguration(actionType, record);
    //   }),
  };

  const childReportHandlers = {
    ...reportActionHandler,
  };

 const resetHandle = async (record: any): Promise<boolean> => {
  return new Promise((resolve) => {
    confirm({
      content: "Are you sure you want to reset?",
      okText: "Ok",
      cancelText: "Cancel",
      async onOk() {
        try {
          showLoader();

          const response = await API.post(updateEmployeeSubmissionFinalDetails, {
            //EmployeeSubmissionId: record.Id,
            UserId:record.EmployeeUserId,
            FinancialYearId: currentFinancialYearId,
          });

          if (response?.data?.status == 0) {
            message.success("Data reset successfully");

            // Optional: Force re-render or reload
            // navigate(`${location.pathname}?refresh=${Date.now()}`, { replace: true });
            resolve(true);
          } else {
            message.error("Error occurred while resetting the data");
            resolve(false); 
          }
        } catch (error) {
          message.error("Failed to perform reset");
          resolve(false);
        } finally {
          hideLoader();
        }
      },
      onCancel() {
        resolve(false); 
      },
    });
  });
};


const bulkDataDownload = async (record: any): Promise<boolean> =>{
  return new Promise((resolve) => {
    confirm({
      content: "Are you sure you want to download all documents for this employee?",
      okText: "Ok",
      cancelText: "Cancel",
      async onOk() {
        try {
          showLoader();
          console.log('records is after ok ',record)
          // const response = await API.post(updateEmployeeSubmissionFinalDetails, {
          //   //EmployeeSubmissionId: record.Id,
          //   UserId:record.EmployeeUserId,
          //   FinancialYearId: currentFinancialYearId,
          // });

          // if (response?.data?.status == 0) {
          //   message.success("Data reset successfully");

          //   // Optional: Force re-render or reload
          //   // navigate(`${location.pathname}?refresh=${Date.now()}`, { replace: true });
          //   resolve(true);
          // } else {
          //   message.error("Error occurred while resetting the data");
          //   resolve(false); 
          // }

          // await getEmpInfo(record.EmployeeUserId);
          // await getform(record.EmployeeUserId);

          let res = await getbulkdocument(record);
          if(res){
            resolve(true);
          }else{
              resolve(false);
          }
          hideLoader();
        } catch (error) {
          message.error("Failed to download documents");
          resolve(false);
        } finally {
          hideLoader();
        }
      },
      onCancel() {
        resolve(false); 
      },
    });
  });
}

  const getEmpInfo =async(Id:any)=>{
    const res = await API.post(empFormData,{
        UserId : Id,
        FinancialYearId : currentFinancialYearId
    })
    //console.log('form 12 bb response=>',res)
    if(res.data.data){
        setEmpName(res?.data?.data[0]?.employeeName)
        setPanNo(res?.data?.data[0]?.pan)
        setMobNo(res?.data?.data[0]?.mobileNo)
        setFinancialYear(res?.data?.data[0]?.financialCycle)
        setFatherName(res?.data?.data[0]?.fatherName)
        setAddress(res?.data?.data[0]?.address)

    }
  }
  const getform =async(Id:any)=>{
      const res = await API.post(getFormData,{
          UserId : Id,
          FinancialYearId : currentFinancialYearId
      })
      //console.log('form 12 form data response=>',res)
      if(res.data.data){
          setFormData(res?.data?.data);
      }
  }

  const getbulkdocument= async(record:any)=>{
    let status = false;
    console.log('curent reocrd click is ',record)
      let userId = record?.EmployeeUserId
      let response = await API.post(fetchAllDocofEmployee, {
              FinancialYearId: currentFinancialYearId,
              UserId: userId,
            });
      console.log('res of bulk doc',response?.data?.data)

      let allDocs = response?.data?.data || [];

      const updatedDocs = await Promise.all(
      allDocs?.map(async (doc: any) => {
        const viewResponse = await API.post(viewFile, {
          FilePath: doc?.filePath,
        });
        console.log('response if view file',viewResponse)
        return {
          ...doc,
          fileData: viewResponse?.data?.data || null, // Add FileData from response
        };
      })
    );

    console.log("Updated documents with fileData:", updatedDocs);

    // Now you can pass updatedDocs to a download function, setState, etc.
  

      // if (filePath) {
      //         let response = await API.post(viewFile, {
      //           FilePath: filePath,
      //         });
      
      //         if (response.data && response.data.data) {
      //           base64data = response.data.data;
      //         }
      //       }

      // const zip = new JSZip();
      // const folder = zip.folder("DownloadedFiles"); // optional folder inside zip

      // for (const file of files) {
      //   try {
      //     const response = await fetch(file.url);
      //     const blob = await response.blob();
      //     folder.file(file.name, blob); // add to zip folder
      //   } catch (err) {
      //     console.error(`Failed to fetch ${file.name}`, err);
      //   }
      // }

      // // Generate and trigger download
      // zip.generateAsync({ type: "blob" }).then((zipBlob) => {
      //   saveAs(zipBlob, "AllDocuments.zip");
      // });

      const zip = new JSZip();
      //const folder = zip.folder("DownloadedFiles"); // optional folder inside zip

      // for (const file of updatedDocs) {
      //   if (file?.fileData) {
      //      zip.file(`${file?.fileName}_${}`, file.fileData, { base64: true });
      //   }
      // }
      const folderMap: { [key: string]: JSZip } = {};

      updatedDocs?.forEach((file, index) => {
      const sectionName = file?.sectionName?.trim() || "Uncategorized";

      // Reuse or create folder
      if (!folderMap[sectionName]) {
        folderMap[sectionName] = zip.folder(sectionName)!;
    }

    if (file?.fileData) {
      const timestamp = Date.now();
      const baseName = file?.fileName?.split(".")[0] || "document";
      const ext = file?.fileName?.split(".").pop() || "pdf";

      const safeName = `${baseName}_${timestamp}_${index}.${ext}`;
      folderMap[sectionName].file(safeName, file.fileData, { base64: true });
    }
  });


  zip.generateAsync({ type: "blob" }).then((zipBlob) => {
    saveAs(
      zipBlob,
      `${record?.EmployeeName}_${record?.EmployeeCode}_Documents.zip`
    );
    message.success("All documents downloaded successfully!");
    status =  true;
  });


    // updatedDocs?.forEach((file,index) => {
    //   const folder = zip.folder(file.sectionName);
    //   console.log('current fle',file)
    //   if (file?.fileData) {
    //     const timestamp = Date.now();
    //     const baseName = file?.fileName?.split(".")[0] || "document";
    //     const ext = file?.fileName?.split(".").pop() || "pdf";

    //     const safeName = `${baseName}_${timestamp}_${index}.${ext}`;
    //     zip.file(safeName, file?.fileData, { base64: true });
    //   }
    // });

    //   zip.generateAsync({ type: "blob" }).then((zipBlob) => {
    //     saveAs(zipBlob, `${record?.EmployeeName}_${record?.EmployeeCode}_Documents.zip`);

    //      message.success("All documents downloaded successfully!");

    //   });
    return status;
      
  }


  const generatePDF = async () => {
   // console.log('generate pdf inside')
      if (!targetRef.current) {
        message.error('PDF content is not ready.');
        return;
      }
  
      
      const clone = targetRef.current.cloneNode(true) as HTMLElement;
      clone.querySelectorAll('.no-print').forEach(el => el.remove());
  
    
      const container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.top = '-9999px';
      container.appendChild(clone);
      document.body.appendChild(container);
  
      try {
        await new Promise(resolve => setTimeout(resolve, 100));
        const canvas = await html2canvas(clone, { scale: 2 });
        //const imgData = canvas.toDataURL('image/png');
        const imgData = canvas.toDataURL('image/jpeg', 1);
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
        pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth - 20, pdfHeight);
        pdf.save('form-12bb.pdf');
      } catch (error) {
        console.error('PDF generation error:', error);
        message.error('Something went wrong while generating the PDF.');
      }
  
      document.body.removeChild(container);
    };

  const formDownloadHandle =async(record:any)=>{
   // console.log(' download record==>',record)
    await getEmpInfo(record.EmployeeUserId);
    await getform(record.EmployeeUserId);
   // console.log('in reset handle ')
  }

  useEffect(() => {

    if (empName && formData?.length > 0) {
     // console.log('inside useeffect')
      setTimeout(() => {
        generatePDF();
      }, 1000); 
    }
  }, [empName, formData]);


  return (
    <>

      <ActionHandlerProvider
        rowActionHandler={childRowHandlers}
        reportActionHandler={childReportHandlers}
      >
        <DynamicReport
          // handleCreate={handleCreate}
          // actionColumn={actionColumn}
          id={0}
          dashboardId={dashboardId}

        />

      </ActionHandlerProvider>

      <div ref={targetRef} style={{ position: 'absolute', left: '-9999px', top: '0' }}>
        {/* <head> */}
            <title>Form 12BB</title>
        {/* </head> */}
        {/* <body> */}
            <div style={{ width: '100%', marginBottom: '20px' }}>
                <h3 style={{ borderBottom: '1px solid #8FA5CD', width: '20%', margin: '0 auto' }}>Form No. 12BB</h3>
                <p>(See Rule 26C)</p>
                <p>Statement showing particulars of claim by an employee for deduction of tax under section 192</p>

                <div style={{ marginBottom: '10px' }}>
                    <div style={{ width: '100%', display: 'flex',   marginBottom: '10px', justifyContent: 'flex-start',alignItems: 'flex-start' }}>
                    {/* <div style={{ width: '10%' }}></div> */}
                    <div style={{ width: '40%', textAlign: 'left' }}>
                        <p style={{ margin: 0 }}><b>Name of the employee: </b>{empName}</p>
                        <p style={{ margin: 0 }}><b>Mobile No:</b> {mobNo}</p>
                    </div>
                    <div style={{ width: '40%', textAlign: 'left' }}>
                        <p style={{ margin: 0 }}><b>PAN of the Employee: </b>{panNo}</p>
                        <p style={{ margin: 0 }}><b>Financial Year:</b> {financialYear}</p>
                    </div>
                    <div style={{ width: '10%' }}></div>
                    </div>
                    <div style={{ width: '50%', margin: '0 auto' }}>
                    </div>
                </div>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid' }}>
                <thead style={{ textAlign: 'left', background: '#D5DBFF', borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                  <tr>
                    <th style={{ padding: '4px' }}>Sr No</th>
                    <th style={{ padding: '4px', width: '30%' }}>Components</th>
                    <th style={{ padding: '4px' }}>Projected Saving</th>
                    <th style={{ padding: '4px' }}>Investment Proof Submitted</th>
                    <th style={{ padding: '4px' }}>Maximum Eligible</th>
                    <th style={{ padding: '4px' }}>Eligible Amount</th>
                    <th style={{ padding: '4px' }}>Approved Amount</th>
                    <th style={{ padding: '4px' }}>No of Docs</th>
                    <th style={{ padding: '4px' }}>Reason</th>
                  </tr>
                </thead>
                <tbody>
                    {formData && 
                        formData.map((obj:any,index : any)=>
                          (
                            <tr style={{ borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                            <td style={{ padding: '4px' }}>{index + 1}</td>
                            <td style={{ padding: '4px' }}>{obj.componentName == null? obj?.sectionName : obj?.componentName}</td>
                            <td style={{ padding: '4px' }}>{obj.projectedSaving ? obj?.projectedSaving : 0}</td>
                            <td style={{ padding: '4px' }}>{obj.investmentProofSubmitted ? obj?.investmentProofSubmitted : 0}</td>
                            <td style={{ padding: '4px' }}>{obj.maximumEligible ? obj?.maximumEligible : 0}</td>
                            <td style={{ padding: '4px' }}>{obj.eligibleAmount ? obj?.eligibleAmount :0 }</td>
                            <td style={{ padding: '4px' }}>{obj.approvedAmount ? obj?.approvedAmount : 0}</td>
                            <td style={{ padding: '4px' }}>{obj.noOfDoc ? obj?.noOfDoc : 0}</td>
                            <td style={{ padding: '4px' }}>{""}</td>
                            </tr>
                          )
                        )
                    }
                    
                </tbody>
            </table>

            <form style={{ marginTop: '20px' }} action="" method="post" onSubmit={(e) => e.preventDefault()}>
                <div style={{ width: '100%', display: 'flex' }}>
                    <div style={{ width: '25%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <label>Designation</label>
                    <input disabled type="text" name="designation" required style={{ width: '90%', padding: '5px 7px' }} />
                    </div>
                    <div style={{ width: '25%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <label>Father's Name</label>
                    <input disabled type="text" name="fatherName" required style={{ width: '90%', padding: '5px 7px' }} value={fatherName}/>
                    </div>
                    <div style={{ width: '25%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <label>Address</label>
                    <input disabled type="text" name="address" required style={{ width: '90%', padding: '5px 7px' }} value={address}/>
                    </div>
                    <div style={{ width: '25%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <label>Place</label>
                    <input disabled type="text" name="place" required style={{ width: '90%', padding: '5px 7px' }} />
                    </div>
                </div>

                
                <div className="no-print" style={{ marginTop: '15px', textAlign: 'end' }}>
                <div style={{ marginTop: '15px', textAlign: 'end' }}>
                    {/* <input type="button" value="Back" style={{ padding: '5px 15px', backgroundColor: '#B7B4B1', border: '1px solid #B7B4B1', color: '#fff', marginRight: '15px' }} /> */}
                    {/* <input onClick={async()=>await generatePDF()} type="button" value="Submit" style={{ padding: '5px 15px', backgroundColor: '#538234', border: '1px solid #538234', color: '#fff' }} /> */}
                </div>
                </div>
            </form>   
        
        {/* </body> */}
      </div>
    </>
  )
}

export default EmployeeRecord
